import { List } from "immutable";
import { createAction } from "redux-actions";
import * as AlertActions from "../../actions/NotificationActions";
import { Thunk } from "../../actions/Thunk";
import * as M from "../../models";
import { Api } from "../../services/Api";

const prefix = "ADMIN_ABSTRACTTYPE_";

export class Constants {
    public static INVITATION_STATUS_SUBSCRIBED = prefix + "INVITATION_STATUS_SUBSCRIBED";
    public static INVITATION_STATUS_UPDATED = prefix + "INVITATION_STATUS_UPDATED";
    public static LOADING_ABSTRACTTYPE = prefix + "LOADING_ABSTRACTTYPE";
    public static LOADING_ABSTRACTTYPES = prefix + "LOADING_ABSTRACTTYPES";
    public static UPDATED_ABSTRACTTYPES = prefix + "UPDATED_ABSTRACTTYPES";
}

interface InvitationStatusSubscribedPayload {
    abstractTypeId: number;
    subscribed: boolean;
}

interface LoadingTypePayload {
    id: number;
    loading: boolean;
}

export const loadTypes = (eventId: number): Thunk => async (dispatch, getState) => {
    const state = getState();
    const api = new Api(state);
    const qp = { queryParams: { eventId }};
    const result = await api.get(Api.endpoints.admin.abstractType.types, qp);

    if (result.isSuccess && result.data)
        dispatch(updateTypes(result.data));
    else
        dispatch(AlertActions.notifyError(M.Result.Result.errorsOrMessage(result).join("<br />")));

    dispatch(toggleLoadingTypes(false));
};

export const loadType = (id: number): Thunk => async (dispatch, getState) => {
    const state = getState();
    const api = new Api(state);
    const result = await api.get(Api.endpoints.admin.abstractType.type.withUrlParams({ id }));

    if (result.isSuccess && result.data)
        dispatch(updateType(result.data));
    else
        dispatch(AlertActions.notifyError(M.Result.Result.errorsOrMessage(result).join("<br />")));

    dispatch(toggleLoadingType(id, false));
};

export const removeType = (item: M.Abstract.AbstractTypeEdit): Thunk => async (dispatch, getState) => {
    const list = getState().adminAbstractType.types;
    const idx = list.findIndex((x: M.Abstract.AbstractTypeEdit) => x.id === item.id);
    if (idx > -1)
        dispatch(onTypesUpdated(list.remove(idx)));
};

export const subscribeToInvitationUpdates = (abstractTypeId: number): Thunk => async (dispatch, getState) => {
    const sub = getState().adminAbstractType.subscribedInvitationUpdates.find((x) => x !== undefined && x.abstractTypeId === abstractTypeId);
    if (sub !== undefined)
        return;

    const connection = getState().abstract.websocket;
    if (!connection)
        return;

    try {
        connection.on("AbstractsInvitationEmailStatusUpdated", (obj: M.Abstract.InvitationEmailStatusUpdate) => {
            if (obj.abstractTypeId === abstractTypeId) {
                console.log("status update received", obj);
                dispatch(updateInvitationStatus(obj));
            }
        });

        connection.on("AbstractsInvitationEmailStatusSubscribed", (id) => {
            if (id === abstractTypeId) {
                console.log("subscribed to abstract type invitation email status updates", id);
                dispatch(onInvitationStatusSubscribed(id, true));
            }
        });

        await connection.invoke("SubscribeInvitationEmailStatus", abstractTypeId);
    }
    catch (err) {
        console.warn("Subscription error", abstractTypeId, err);
    }
};

export const updateInvitationStatus = (item: M.Abstract.InvitationEmailStatusUpdate): Thunk => async (dispatch, getState) => {
    let list = getState().adminAbstractType.subscribedInvitationUpdates;
    const idx = list.findIndex((x) => x !== undefined && x.abstractTypeId === item.abstractTypeId);
    if (idx > -1) {
        const sub = { ...list.get(idx) };
        sub.sent = item.sent;
        sub.total = item.total;
        sub.done = item.done;
        list = list.set(idx, sub);
        dispatch(onInvitationStatusUpdated(list));
    }
};

export const updateType = (item: M.Abstract.AbstractTypeEdit): Thunk => async (dispatch, getState) => {
    dispatch(updateTypes([item]));
};

export const updateTypes = (updatedList: M.Abstract.AbstractTypeEdit[]): Thunk => async (dispatch, getState) => {
    let list = getState().adminAbstractType.types;
    updatedList.map((item: M.Abstract.AbstractTypeEdit) => {
        const idx = list.findIndex((x: M.Abstract.AbstractTypeEdit) => x.id === item.id);
        list = idx > -1
            ? list.set(idx, item)
            : list.push(item);
    });

    dispatch(onTypesUpdated(list));
};

export const onInvitationStatusSubscribed = createAction<InvitationStatusSubscribedPayload, number, boolean>(
    Constants.INVITATION_STATUS_SUBSCRIBED, (abstractTypeId, subscribed) => ({ abstractTypeId, subscribed }),
);

export const onInvitationStatusUpdated = createAction<List<M.Abstract.InvitationEmailStatusUpdate>, List<M.Abstract.InvitationEmailStatusUpdate>>(
    Constants.INVITATION_STATUS_UPDATED, (list) => (list),
);

export const onTypesUpdated = createAction<List<M.Abstract.AbstractTypeEdit>, List<M.Abstract.AbstractTypeEdit>>(
    Constants.UPDATED_ABSTRACTTYPES, (list) => (list),
);

export const toggleLoadingType = createAction<LoadingTypePayload, number, boolean>(
    Constants.LOADING_ABSTRACTTYPE, (id, loading) => ({ id, loading }),
);

export const toggleLoadingTypes = createAction<boolean, boolean>(
    Constants.LOADING_ABSTRACTTYPES, (loading) => (loading),
);



// WEBPACK FOOTER //
// ./src/store/adminAbstractType/AdminAbstractTypeActions.ts